import { useState } from 'react'
import type { ConversationFeedback } from '../lib/api'

// 留意見的附加選單（#1446）。🔴 沒有讚踩、沒有星等、沒有任何純量評分：
// 就是一段話，寫完送出。入口常駐但收著，不佔版面也不干擾閱讀。

export const FEEDBACK_SENT_TEXT = '已收到，謝謝你的意見。'
export const FEEDBACK_PLACEHOLDER = '這個回答哪裡有問題？或是哪裡幫上忙了？'

interface FeedbackMenuProps {
  /** 要送出的輪次；0 代表整份對話 */
  turn: number
  label: string
  /** 自己在這一輪留過的幾則，直接回顯 */
  entries: ConversationFeedback[]
  onSubmit: (turn: number, content: string) => Promise<void>
}

type Status = 'idle' | 'sending' | 'sent' | 'error'

export function FeedbackMenu({ turn, label, entries, onSubmit }: FeedbackMenuProps) {
  const [text, setText] = useState('')
  const [status, setStatus] = useState<Status>('idle')
  const [failure, setFailure] = useState<string | null>(null)

  // 純新增：同一輪送兩次就是兩則。送出成功才清空輸入框，失敗時把字留著讓人重試。
  const send = () => {
    const content = text.trim()
    if (!content || status === 'sending') return
    setStatus('sending')
    void onSubmit(turn, content)
      .then(() => {
        setText('')
        setFailure(null)
        setStatus('sent')
      })
      .catch((e: Error) => {
        setFailure(e.message)
        setStatus('error')
      })
  }

  return (
    <div className="feedback" data-turn={turn}>
      {entries.length > 0 && (
        <ul className="feedback-mine">
          {entries.map((entry) => (
            <li key={entry.feedbackId} className="feedback-mine-item">{entry.content}</li>
          ))}
        </ul>
      )}
      <details className="feedback-menu">
        <summary>{label}</summary>
        <div className="feedback-body">
          <textarea
            className="feedback-input"
            aria-label={label}
            placeholder={FEEDBACK_PLACEHOLDER}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <div className="feedback-actions">
            <button
              className="feedback-send"
              onClick={send}
              disabled={!text.trim() || status === 'sending'}
            >
              {status === 'sending' ? '送出中…' : '送出'}
            </button>
            {status === 'sent' && <span className="feedback-ok">{FEEDBACK_SENT_TEXT}</span>}
            {status === 'error' && <span className="feedback-fail">{failure}</span>}
          </div>
        </div>
      </details>
    </div>
  )
}
